import ConnectivityStatus from './ConnectivityStatus';

import './ConnectivityStatus.scss';

export default ConnectivityStatus;
